import { useState } from 'react';

import { useServerClient } from '../useServerClient';
import { useServerParams } from '../useServerParams';

import { userTypes } from './useUsers';
// import { branchUserTypes } from './useBranchUsers';
import { itemTypes } from './useItems';

export const customFieldTypes = {
    account: "custom_field"
}

export const customFieldModules = {
    item: "item",
    // document: "document",
    user: "user"
}

export const customFieldFunctions = {
    item: {
        item: itemTypes.item
    },
    // document: {
    //     salesOrder: "sales_order",
    //     deliveryOrder: "delivery_order",
    // },
    user: {
        admin: userTypes.admin,
        worker: userTypes.worker,
        customer: userTypes.customer,
        supplier: userTypes.supplier,
        retailer: userTypes.retail,
        driver: userTypes.driver,
        member: userTypes.member,
        customerBranchUser: "customer_branch_user",
        retailBranchUser: "retailer_branch_user",
    }
}

export function useCustomFields({
    customFieldModule: _customFieldModule = '',
    customFieldFunction: _customFieldFunction = ''
}) {

    const [fieldModule, setFieldModule] = useState(_customFieldModule);
    const [fieldFunction, setFieldFunction] = useState(_customFieldFunction);

    const { makeCall, getError } = useServerClient();
    const { getListsUrl, _operatorDef: filterOperatorTypes } = useServerParams();

    const [isLoading, setIsLoading] = useState(false)

    const endpoint = "custom_fields";
    const endpoint2 = "custom_field";

    const list = async (props) => {

        setIsLoading(true);

        try {

            let endpointUrl = `${endpoint}/custom_field`

            const url = getListsUrl(endpointUrl, props);

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const create = async ({ data }) => {

        setIsLoading(true)

        try {

            const url = `${endpoint2}`;

            let postData = {
                scope: {
                    target: "custom_field",
                    action: "",
                },
                payload: data
            }

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const update = async ({ id, data }) => {

        setIsLoading(true)

        try {

            const url = `${endpoint2}/${id}`

            const postData = {
                scope: {
                    target: "custom_field",
                    action: "",
                },
                payload: data
            }

            const response = await makeCall({
                url,
                method: "PUT",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const get = async ({ id }) => {

        setIsLoading(true);

        try {

            const url = `${endpoint2}/custom_field/${id}`

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const remove = async ({ ids }) => {

        setIsLoading(true);

        if (ids.length <= 0) {
            throw getError(false, `Please select at least (1) items`)
        }

        try {

            const url = `${endpoint}/delete`

            const postData = {
                scope: {
                    target: "custom_field"
                },
                payload: {
                    ids
                }
            }

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    return {
        isLoading,
        filterOperatorTypes,
        customFieldFunctions,
        customFieldModules,
        // targetTypes,
        // setTargetType,
        // setScopeType,
        list,
        get,
        create,
        update,
        remove
    }
}